import { c as _c } from "react/compiler-runtime";
import { useBack } from "@website/hooks/back";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
export function BackButton(t0) {
  const $ = _c(5);
  const {
    isHomePage
  } = t0;
  const {
    goBack
  } = useBack();
  let t1;
  bb0: {
    if (typeof window === "object") {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = new URLSearchParams(window.location.search);
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    t1 = null;
  }
  const search = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function onBackHomePageClick() {
      const isPwa = search?.get("ispwa");
      if (isPwa) {
        window.close();
        return;
      }
      window.location.assign("snpjekhomepage://");
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const onBackHomePageClick = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MaterialIcon name="arrow_forward" variant="outlined" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = isHomePage ? onBackHomePageClick : goBack;
  let t5;
  if ($[3] !== t4) {
    t5 = <Button EndIcon={t3} aria-label="close" className="lg:!hidden" color="neutral" equalDimension={true} onClick={t4} size="small" variant="text" />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
}